var map = {
	"./1.jpg": "./src/data/images/home/1.jpg",
	"./2.jpg": "./src/data/images/home/2.jpg",
	"./3.jpg": "./src/data/images/home/3.jpg",
	"./4.jpg": "./src/data/images/home/4.jpg",
	"./5.jpg": "./src/data/images/home/5.jpg",
	"./6.jpg": "./src/data/images/home/6.jpg",
	"./7.jpg": "./src/data/images/home/7.jpg",
	"./8.jpg": "./src/data/images/home/8.jpg",
	"./9.jpg": "./src/data/images/home/9.jpg",
	"./Pano copy 2.jpg": "./src/data/images/home/Pano copy 2.jpg",
	"./Pano copy.jpg": "./src/data/images/home/Pano copy.jpg",
	"./Pano.jpg": "./src/data/images/home/Pano.jpg",
	"./Pano1.jpg": "./src/data/images/home/Pano1.jpg",
	"./Pano_ER.jpg": "./src/data/images/home/Pano_ER.jpg",
	"./SummerSession.png": "./src/data/images/home/SummerSession.png",
	"./about.jpg": "./src/data/images/home/about.jpg",
	"./background.jpg": "./src/data/images/home/background.jpg",
	"./background_1.jpg": "./src/data/images/home/background_1.jpg",
	"./background_2.jpg": "./src/data/images/home/background_2.jpg",
	"./background_3.jpg": "./src/data/images/home/background_3.jpg",
	"./background_books.jpg": "./src/data/images/home/background_books.jpg",
	"./background_fire.jpg": "./src/data/images/home/background_fire.jpg",
	"./background_leather.jpg": "./src/data/images/home/background_leather.jpg",
	"./calendar.svg": "./src/data/images/home/calendar.svg",
	"./cathedral.jpg": "./src/data/images/home/cathedral.jpg",
	"./chapel.jpg": "./src/data/images/home/chapel.jpg",
	"./church_line_drawing.jpg": "./src/data/images/home/church_line_drawing.jpg",
	"./church_line_drawing_whole.png": "./src/data/images/home/church_line_drawing_whole.png",
	"./class.svg": "./src/data/images/home/class.svg",
	"./explore.jpg": "./src/data/images/home/explore.jpg",
	"./headset.svg": "./src/data/images/home/headset.svg",
	"./history.svg": "./src/data/images/home/history.svg",
	"./iota.jpg": "./src/data/images/home/iota.jpg",
	"./iota.png": "./src/data/images/home/iota.png",
	"./iota_png.png": "./src/data/images/home/iota_png.png",
	"./listen.png": "./src/data/images/home/listen.png",
	"./logo.png": "./src/data/images/home/logo.png",
	"./logo1 copy.png": "./src/data/images/home/logo1 copy.png",
	"./logo1.png": "./src/data/images/home/logo1.png",
	"./logo1_black.png": "./src/data/images/home/logo1_black.png",
	"./logo1_cropped.png": "./src/data/images/home/logo1_cropped.png",
	"./logo1_take1.png": "./src/data/images/home/logo1_take1.png",
	"./logo1_vertical.png": "./src/data/images/home/logo1_vertical.png",
	"./logo1_white.png": "./src/data/images/home/logo1_white.png",
	"./logo_color.png": "./src/data/images/home/logo_color.png",
	"./moosh_logo.png": "./src/data/images/home/moosh_logo.png",
	"./podcast.svg": "./src/data/images/home/podcast.svg",
	"./st_john.png": "./src/data/images/home/st_john.png",
	"./st_john_icon.jpg": "./src/data/images/home/st_john_icon.jpg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/data/images/home sync \\.(png|jpe?g|svg)$";